import React, { useCallback, useEffect, useState, useRef } from 'react';
import styles from './UserSurvey.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import {
  // CONTEXT,
  SURVEY_USER_80,
  APP_VERSION,
  APP_VERSION_D,
  APP_VERSION_CODE,
  APP_VERSION_CODE_D,
} from '../config';
import { useHistory } from 'react-router-dom';
import { createAxios, logNative } from '../utils/utils';
import { cacheKeys, SURVEY_USER_UPDATE_TIME } from '../constants/storageKeys';
import { logging } from '../actions/log';

const selectLayoutInfo = createSelector(
  state => state.layout,
  layout => ({ activeMenu: layout.activeMenu }),
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default function () {
  const { activeMenu } = useSelector(selectLayoutInfo);
  const history = useHistory();
  const [survey, setSurvey] = useState(null);
  const repeatTimer = useRef(null);
  const onceTimer = useRef(null);
  const [show, setShow] = useState(false);
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();

  const getSurveyInfo = useCallback(async () => {
    // const lastRequestTime = +(localStorage.getItem(SURVEY_USER_UPDATE_TIME) || 0);
    // if (Date.now() - lastRequestTime < 24 * 60 * 60 * 1000) {
    //   return;
    // } // 时间间隔1天

    try {
      const machineInfoStr = localStorage.getItem(cacheKeys.LOCALMACHINE_INFO);
      const machineInfo = JSON.parse(machineInfoStr);
      const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}') || {};

      const axios = await createAxios();
      const {
        data: { data, status, message },
      } = await axios.post(SURVEY_USER_80, {
        productInfo: {
          code: 'pcstore',
          versionName: machineInfo.leas_runtime === 'independent' ? APP_VERSION_D : APP_VERSION,
          versionCode:
            machineInfo.leas_runtime === 'independent' ? APP_VERSION_CODE_D : APP_VERSION_CODE,
        },
        deviceInfo: {
          sn: startInfo.SN || 'SN',
          mt: machineInfo.MT || 'MT',
          os: machineInfo.OS || 'OS',
          osBit: machineInfo.OSbit || 'OSbit',
          uuid: machineInfo.ludp_uuid,
          mac: machineInfo.MAC,
        },
      });
      logNative(`请求用改中心接口 返回数据${JSON.stringify(data)}`);
      if (status === 0 && data.hasSurvey === 1 && data.surveyUrl) {
        localStorage.setItem(SURVEY_USER_UPDATE_TIME, Date.now()); // 更新时间
        setSurvey(data);
        clearTimeout(onceTimer.current);
        clearInterval(repeatTimer.current);
      }
      dispatch(
        logging({
          category: 'R',
          action: 'Ue_Request',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            status: status === 0 ? 1 : 0,
            mes: message,
            id: data?.surveyId,
            pop_type: data?.surveyType,
          },
        }),
      );
    } catch (err) {
      logNative(`用改中心接口报错：${err}`);
    }
  }, []);

  const handleMessage = useCallback(data => {
    try {
      const msg = (JSON.parse(data.data) || {}).msg;
      if (msg === 'NPS_MESSAGE_REQ_OPEN') {
        setShow(true);
      } else if (msg === 'NPS_MESSAGE_REQ_CLOSE') {
        setSurvey(null);
      }
    } catch (err) {}

    // onceTimer.current = null;
    // repeatTimer.current = null;
  }, []);

  useEffect(() => {
    if (
      activeMenu && // 选中菜单
      history.length > 1 && // 不是首页
      !repeatTimer.current &&
      !onceTimer.current
    ) {
      repeatTimer.current = setInterval(getSurveyInfo, 30 * 60 * 1000); //30分钟轮询
      onceTimer.current = setTimeout(getSurveyInfo, 5 * 1000); //点击菜单5s发起请求
    }
    logNative(`activeMenu ${activeMenu}`);
    logNative(` history.length ${history.length}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenu, history.length]);

  // // 接受关闭弹窗消息
  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  });

  if (!survey) {
    return null;
  }
  return (
    <div className={styles.modal} style={{ display: show ? 'block' : 'none' }}>
      <iframe
        src={survey && survey.surveyUrl}
        // src={
        //   'http://127.0.0.1:3001/popup/user/freenps?bizKey=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdXJ2ZXlJZCI6IjQ1IiwiaXNQcmV2aWV3IjowLCJvcyI6IndpbjEwIiwic25IYXNoIjoiYzE5OWUwMjRmNTE4OGY2OTUxYTczYzE2ZThhZTAwMmI1NmJlZjNkMTA0ZDNhNGU0NTc3YWMzYWRiNzhiNTdiZCIsIm10IjoiTGVub3ZvIFhpYW9YaW5BaXItMTRJSUwgMjAyMCIsInRpdGxlIjoiIiwidXVpZCI6IkY2OTEzRDE3LTA4NDQtMTFFQi04MTA3LTdDOEFFMTUyMjQ1OSIsIm1hYyI6Ijk0ZTcwYmU5YmE2MCIsInN1cnZleUluZm9LZXkiOiIyX3Bjc3RvcmUiLCJ2ZXJzaW9uQ29kZSI6Ijc2MDAwIiwiaXNMb2NrIjowLCJwcm9kdWN0Q29kZSI6InBjc3RvcmUiLCJvc0JpdCI6IjY0IiwiaXNGdWxsIjowLCJzbiI6Ik1QMVZEUEJIIiwiZXhwIjoyMjc2OTEwMDE4LCJ0YXJnZXRVcmwiOiIiLCJkZXNjIjoiIn0.Su48esN1sNXejYXkYd9aGaL-Dt8gycTF5hlA10hXDIc&surveyId=45&sn=MP1VDPBH&mt=Lenovo XiaoXinAir-14IIL 2020&versionCode=76000'
        // }
        frameBorder={0}
        title="用改中心"
        width={395}
        // 1:nps 2.survey
        height={survey?.surveyType === 1 ? 165 : 190}
      />
    </div>
  );
}
